import { render, staticRenderFns } from "./TextRecommendationPreview.vue?vue&type=template&id=030b5737&scoped=true"
import script from "./TextRecommendationPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendationPreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendationPreview.vue?vue&type=style&index=0&id=030b5737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030b5737",
  null
  
)

export default component.exports